import { ChevronRight } from 'lucide-react';
import type { Selection } from '@shared/types/room';
import { shortLabel } from '@shared/game/logic';

export function SelectionPath({ selections }: { selections: Selection[] }) {
  if (selections.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" aria-label="현재까지 선택">
      <span className="mr-1 text-xs font-semibold text-charcoal-500">현재까지</span>
      {selections.map((s, i) => (
        <span key={s.stage} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={14} className="text-charcoal-500/60" aria-hidden="true" />}
          <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-1 text-sm font-medium text-primary-700 animate-pop-in">
            <span aria-hidden="true">{s.emoji}</span>
            {shortLabel(s)}
          </span>
        </span>
      ))}
    </div>
  );
}
